import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

const StyledLockupWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 22px;
`

const MarieCurieXFarewillLogo = () => (
  <StyledLockupWrapper>
    <a
      aria-label="Visit Marie Curie's homepage"
      href="https://www.mariecurie.org.uk/"
    >
      <img
        alt="Marie Curie"
        height="50"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/marie-curie/marie-curie-logo.svg`}
      />
    </a>
    <a aria-label="Visit Farewill's homepage" href="https://farewill.com">
      <img
        alt="Marie Curie"
        height="40"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/x-Farewill.svg`}
      />
    </a>
  </StyledLockupWrapper>
)

export default MarieCurieXFarewillLogo
